export const translations = {
  fr: {
    // Header
    hello: "Bonjour, je suis",
    fullstackDeveloper: "Développeur FullStack",
    scrollDown: "Allez en bas",
    
    // Navigation
    home: "Accueil",
    about: "À propos",
    experience: "Expérience",
    portfolio: "Portfolio",
    contact: "Contact",
    
    // About section
    getToKnow: "Me connaitre",
    aboutTitle: "A propos",
    experienceLabel: "Expérience",
    clients: "Clients",
    projects: "Projets",
    aboutText: "Passionné par l'univers du web et mobile et doté d'une grande curiosité, je suis aujourd'hui développeur web Full Stack.",
    contactMe: "Contactez moi",
    
    // Experience section
    experienceTitle: "Mon expérience",
    experienceSubtitle: "Ce que j'ai accompli",
    skillsTitle: "Les compétences que j'ai",
    skillsSubtitle: "Mes compétences",
    frontendTitle: "Technologies frontend utilisées",
    backendTitle: "Technologies Backend utilisées",
    databaseTitle: "Database",
    uiDesignTitle: "Design d'interface utilisateur",
    othersTitle: "Autres",
    experienced: "Expérimenté",
    good: "Bon",
    computerMaintenance: "Maintenance informatique",
    
    // Portfolio section
    portfolioTitle: "Mon Portfolio",
    portfolioSubtitle: "Mon travail récent",
    viewProject: "Voir le projet",
    viewCode: "Voir le code",
    
    // Contact section
    contactTitle: "Contactez moi",
    contactSubtitle: "Entrez en contact",
    getInTouch: "Entrez en contact",
    contactText: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dignissimos, ratione error est recusandae consequatur, iusto illum deleniti quidem impedit, quos quaerat quis minima sequi tempore officiis ab perferendis?",
    sendMessage: "Envoyer un message",
    
    // Footer
    footerText: "Tous droits réservés",
    
    // Form labels
    name: "Nom complet",
    email: "Votre Email",
    subject: "Sujet",
    message: "Votre message",
    
    // Buttons
    send: "Envoyer",
    download: "Télécharger CV",
    
    // Services
    servicesTitle: "Mes Services",
    servicesSubtitle: "Ce que j'offre",
    webDevelopment: "Développement Web",
    webDevelopmentDesc: "Création de sites web modernes et responsives avec les dernières technologies.",
    mobileDevelopment: "Développement Mobile",
    mobileDevelopmentDesc: "Développement d'applications mobiles natives et cross-platform.",
    uiUxDesign: "Design UI/UX",
    uiUxDesignDesc: "Conception d'interfaces utilisateur intuitives et esthétiques.",
    
    // Years and counts
    years: "ans",
    plus: "+"
  },
  
  en: {
    // Header
    hello: "Hello, I'm",
    fullstackDeveloper: "FullStack Developer",
    scrollDown: "Scroll Down",
    
    // Navigation
    home: "Home",
    about: "About",
    experience: "Experience",
    portfolio: "Portfolio",
    contact: "Contact",
    
    // About section
    getToKnow: "Get To Know",
    aboutTitle: "About Me",
    experienceLabel: "Experience",
    clients: "Clients",
    projects: "Projects",
    aboutText: "Passionate about web and mobile development with great curiosity, I am now a Full Stack web developer.",
    contactMe: "Contact Me",
    
    // Experience section
    experienceTitle: "My Experience",
    experienceSubtitle: "What I've accomplished",
    skillsTitle: "The skills I have",
    skillsSubtitle: "My skills",
    frontendTitle: "Frontend technologies used",
    backendTitle: "Backend technologies used",
    databaseTitle: "Database",
    uiDesignTitle: "User interface design",
    othersTitle: "Others",
    experienced: "Experienced",
    good: "Good",
    computerMaintenance: "Computer maintenance",
    
    // Portfolio section
    portfolioTitle: "My Portfolio",
    portfolioSubtitle: "My recent work",
    viewProject: "View Project",
    viewCode: "View Code",
    
    // Contact section
    contactTitle: "Contact Me",
    contactSubtitle: "Get In Touch",
    getInTouch: "Get In Touch",
    contactText: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Dignissimos, ratione error est recusandae consequatur, iusto illum deleniti quidem impedit, quos quaerat quis minima sequi tempore officiis ab perferendis?",
    sendMessage: "Send Message",
    
    // Footer
    footerText: "All rights reserved",
    
    // Form labels
    name: "Full Name",
    email: "Your Email",
    subject: "Subject",
    message: "Your Message",
    
    // Buttons
    send: "Send",
    download: "Download CV",
    
    // Services
    servicesTitle: "My Services",
    servicesSubtitle: "What I offer",
    webDevelopment: "Web Development",
    webDevelopmentDesc: "Creating modern and responsive websites with the latest technologies.",
    mobileDevelopment: "Mobile Development",
    mobileDevelopmentDesc: "Developing native and cross-platform mobile applications.",
    uiUxDesign: "UI/UX Design",
    uiUxDesignDesc: "Designing intuitive and aesthetic user interfaces.",
    
    // Years and counts
    years: "years",
    plus: "+"
  }
}; 